const STATUS_COLORS = {
	Succeeded: 'success.main',
	Failed: 'error.main',
	Skipped: 'text.secondary',
	NeverSynced: 'text.secondary',
};

export const getTalentLmsSyncTypographyColor = (status) =>
	STATUS_COLORS[status] || 'text.secondary';

export const formatTalentLmsBranchSummary = (branches = []) =>
	branches.map((branch) => branch.label || branch.Label || branch.branchId || branch.BranchId).filter(Boolean);
